<template>
  <div class="Evaluation-modal-overlay">
    <transition name="modal-expand">
    <div v-if="isVisible" class="Evaluation-modal">
      <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
      <h3 class="Evaluation-modal-title" style="color: #474747; font-size: 1.5rem;">Candidate {{ trainee.license_no }} |
        Task Assessment | {{ trainee.last_name }}, {{ trainee.first_name }} {{ formattedBirthInfo }} </h3>
      <table class="assessment-table" style="margin-top: 5px; margin-bottom: 10px;">
        <tbody style="border: 2px solid black;">
          <tr style="border-top: 2px solid black;">
            <td style="border-bottom: 1px solid white; width: 250px; text-align: center">
              <strong>Assessment Task</strong> <br>
            </td>
            <td>
              <div v-if="taskEmptyMessage" class="empty-message">
                {{ taskEmptyMessage }}
              </div>
              <select v-else v-model="taskDetails" :disabled="isSubmitted >= 1"
                style="width:100%; height:50px; padding-left:10px;">
                <option :value="null" disabled>-- Select Assessment Task --</option>
                <option v-for="task in filteredTasks" :key="task.task_id" :value="task">
                  {{ formatTaskDescription(task) }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="artificial-fieldset">
        <label class="artificial-fieldset-legend">Assessment Info</label>
        <table class="additional-info-table">
          <tr>
            <td>
              <strong>Assessment Type:</strong>
            </td>
            <td>
              <input type="text" v-model="assessmentType" disabled>
            </td>
            <td>
              <strong>Rating:</strong>
            </td>
            <td>
              <input type="text" v-model="assessmentCategory" disabled>
            </td>
            <td style="font-weight:bold;">Date:</td>
            <td><input type="date" id="date" name="date" v-model="date" :disabled="isSubmitted != 0" /></td>
          </tr>
          <tr>
            <td>
              <strong>Aircraft Type:</strong>
            </td>
            <td>
              <input type="text" v-model="aircraftType" disabled>
            </td>
            <td>
              <strong>Course Code:</strong>
            </td>
            <td>
              <input type="text" v-model="courseCode" disabled>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Trainee Name:</strong>
            </td>
            <td>
              <input type="text" v-model="traineeName" disabled>
            </td>
            <td>
              <strong>Assessor Name:</strong>
            </td>
            <td>
              <input type="text" v-model="assessorName" disabled>
            </td>
          </tr>
          <tr>
            <td colspan="1">
              <strong>Question:</strong>
            </td>
            <td colspan="3">
              <input type="text" v-model="taskQuestion" disabled style="width: 100%; box-sizing: border-box;">
            </td>
          </tr>
        </table>
      </div>
      <div class="artificial-fieldset" v-if="isSubmitted !== 0">
        <label class="artificial-fieldset-legend">Observe Warnings and Cautions</label>
        <table class="assessment-table" style="margin-top: 25px; margin-bottom: 10px;">
          <tbody style="border: 2px solid black;">
            <tr style="border-top: 2px solid black;">
              <td style=" border-bottom: 1px solid grey;">
                <strong>System Integration with other ATA chapters:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="ataIntegration" style="width: 100%; height: 90px;"
                  disabled></textarea>
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td style=" border-bottom: 1px solid grey;">
                <strong>Location of System Components:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="systemComponents" style="width: 100%; height: 90px;"
                  disabled></textarea>
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td style="border-bottom: 1px solid grey;">
                <strong>Technical Publications reference:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="technicalReference" style="width: 100%; height: 90px;"
                  disabled></textarea>
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td style="border-bottom: 1px solid grey;">
                <strong>Perform Maintenance Actions:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="maintenanceActions" style="width: 100%; height: 90px;"
                  disabled></textarea>
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td style="border-bottom: 1px solid grey;">
                <strong>Possible MEL Deferral:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="melDeferral" style="width: 100%; height: 90px;"
                  disabled></textarea>
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td style="border-bottom: 1px solid grey;">
                <strong>Aircraft final/close-up and reports:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="closeUp" style="width: 100%; height: 90px;" disabled></textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="assessment-table" style="margin-top: 25px; margin-bottom: 10px;">
          <tbody style="border: 2px solid black;">
            <tr style="border-top: 2px solid black;">
              <td style=" border-bottom: 1px solid grey;">
                <strong>(Optional) Extra Info:</strong>
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black;">
                <textarea v-model="extraInfo" style="width: 100%; height: 150px;" disabled></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="assessment-container" v-if="isSubmitted > 2">
        <div class="signature-block">
          <table class="signature-table" style="margin-left: 30px;">
                <tr class="trainee-signature">
                  <td style="font-weight:bold;">TRAINEE SIGNATURE:</td>
                  <td>
                    <canvas ref="traineeSignaturePadCanvas" id="trainee-signature-pad" class="signature-pad" width="280"
                      height="80"></canvas>
                  </td>
                  <td>
                    <!-- <button class="tee-clear-button" @click="clearTraineeSignature"
                      :disabled="isSubmitted > 1">Clear</button> -->
                  </td>
                </tr>
                <tr class="signature">
                  <td style="font-weight:bold">ASSESSOR SIGNATURE:</td>
                  <td>
                    <canvas ref="assessorSignaturePadCanvas" id="assessor-signature-pad" class="signature-pad"
                      width="280" height="80"></canvas>
                  </td>
                  <td>
                    <button class="ins-clear-button" @click="clearAssessorSignature"
                      :disabled="isSubmitted > 3">Clear</button>
                  </td>
                </tr>
          </table>
        </div>
      </div>
      <div class="assessment-result" v-if="isSubmitted > 2">
        <table>
          <tr>
            <td style="font-weight: bold; text-align: right; padding-right: 20px;" :disabled="isSubmitted != 2 && isSubmitted != 3">
              RESULT OF THE ASSESSMENT
            </td>
            <td style="margin-left: 20px; border:none;" :disabled="isSubmitted != 2 && isSubmitted != 3">
              <label>
                <input type="radio" value="pass" v-model="assessmentResult" :disabled="isSubmitted != 2 && isSubmitted != 3"/>
                Passed
              </label>
              <label style="margin-left: 10px;">
                <input type="radio" value="fail" v-model="assessmentResult" :disabled="isSubmitted != 2 && isSubmitted != 3"/>
                Failed
              </label>
            </td>
          </tr>
        </table>
      </div>
      <div class="button-container">
        <button class="ins-close-button" @click="close">Close</button>
        <div class="right">
          <!-- <button class="ins-save-button" @click="save(3)" :disabled="isSubmitted != 2 && isSubmitted != 3">Save</button> -->
          <button v-if="isSubmitted === 0" class="ins-submit-button" @click="submitTaskSelection">Submit</button>
          <button v-if="isSubmitted !== 0" class="ins-submit-button" @click="submitTaskAssessment" :disabled="isSubmitted === 1 || isSubmitted === 2 || isSubmitted === 4">Submit</button>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>
 
<script>
import axios from 'axios';
import { ENABLE_USER_BIRTH_AND_CATEGORY } from '@/config/featureFlags';
import SignaturePad from 'signature_pad';
 
export default {
  props: {
    trainee: {
      type: Object,
      required: true
    },
    instructor: {
      type: Object,
      required: true,
    },
    fetchedData: Object,
    attemptNo: Number,
    mergedTasks: {
      type: Array,
      required: true
    },
    assessment_tasks: {
      type: Array,
      required: true
    },
    trainee_assessments: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      currentCriterionId: null,
      currentConfirmationId: null,
      isSubmitted: 0,
      assessmentEntryId: '',
      instructorId: this.instructor?.user_id ?? null,
      taskDetails: null,
      pendingTaskId: null,
      assessorNotes: '',
      tasksPerformed: '',
      assessorSignature: '',
      traineeSignature: '',
      successfulChecked: false,
      remedialChecked: false,
      date: '',
      traineeId: localStorage.getItem('trainee_id'),
      logbookId: localStorage.getItem('logbook_id'),
      productId: localStorage.getItem('productId'),
      evallogbookId: null,
      assessorSignaturePad: null,
      traineeSignaturePad: null,
      tableType: '',
      assessmentType: '',
      assessmentCategory: '',
      aircraftType: '',
      courseCode: '',
      traineeName: '',
      assessorName: '',
      taskQuestion: '',
      ataIntegration: '',
      systemComponents: '',
      technicalReference: '',
      maintenanceActions: '',
      melDeferral: '',
      closeUp: '',
      extraInfo: '',
      assessmentResult: '',
      product: {},
      aircraft: {},
      specific: {},
      isVisible: false,
    }
  },
  watch: {
    fetchedData(newVal) {
      console.log('Received fetched data:', newVal);
      this.populateTaskAssessmentData(newVal);
    },
    criteriaResults: {
      immediate: true,
      handler() {
        const result = this.assessmentResult;
        this.successfulChecked = result === 'pass';
        this.remedialChecked = result === 'fail';
      }
    },
    isSubmitted(newValue, oldValue) {
      this.$nextTick(() => {
        const assessorCanvas = this.$refs.assessorSignaturePadCanvas;
        const traineeCanvas = this.$refs.traineeSignaturePadCanvas;

        if (newValue > 3) {
          if (this.assessorSignaturePad) {
            this.assessorSignaturePad.off();
          }

          if (this.traineeSignaturePad) {
            this.traineeSignaturePad.off();
          }

          if (assessorCanvas) {
            assessorCanvas.style.opacity = '0.5';
          }

          if (traineeCanvas) {
            traineeCanvas.style.opacity = '0.5';
          }
        } else if (oldValue > 1 && newValue === 1) {
          this.initializeAssessorSignaturePad();
          this.initializeTraineeSignaturePad();
        }
      });
    },
    filteredTasks() {
      this.resolveTaskDetails();
    },
    taskDetails(newTask) {
      if (!newTask) {
        this.assessmentType = '';
        this.assessmentCategory = '';
        this.taskQuestion = '';
        return;
      }
      this.assessmentType = newTask.assessment_type;
      this.assessmentCategory = newTask.category;
      this.taskQuestion = newTask.question;
    },
  },
  computed: {
    isReadOnly() {
      return this.fetchedData && this.fetchedData.is_submitted;
    },
    filteredTasks() {
      return this.assessment_tasks.filter((task) => {
 
        // EXCLUDE tasks already assessed and submitted (is_submitted = 2)
        const alreadyAssessed = this.trainee_assessments.some(assess =>
          assess.id !== this.assessmentEntryId &&       // <-- ignore the current assessment
          Number(assess.assessment_task_id) === Number(task.assessment_task_id) &&
          assess.is_submitted >= 1
        );
 
        return !alreadyAssessed;
      });
    },
    catalogEmptyMessage() {
      if (this.product?.assessment_criteria !== 'AHD') return '';
 
      // Case 1: No catalog assigned
      if (this.product.catalog_id == null) {
        return `There is no catalog assigned to this ${this.$labels.product}. Contact Examiner for assistance.`;
      }
 
      // Case 2: Catalog exists but has no tasks
      if (this.catalog_tasks.length === 0) {
        return `There are no tasks in the catalog assigned to this ${this.$labels.product}. Contact Examiner for assistance.`;
      }
 
      return '';
    },
    formattedBirthInfo() {
      if (!ENABLE_USER_BIRTH_AND_CATEGORY) return '';
      const parts = [
        this.trainee.place_of_birth,
        this.trainee.date_of_birth
      ].filter(v => v && v.toString().trim() !== '');
 
      return parts.length ? `(${parts.join(', ')})` : '';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    resolveTaskDetails() {
      // Requires this.product to already be loaded, since formatTaskDescription
      // depends on this.product.assessment_criteria to format correctly.
      if (!this.pendingTaskId) return;
      if (this.taskDetails) return; // already resolved, don't overwrite a user's manual selection

      const match = this.filteredTasks.find(
        t => Number(t.assessment_task_id) === Number(this.pendingTaskId)
      );

      if (match) {
        this.taskDetails = match;
      } else {
        console.warn('Could not match stored assessment_task_id to an available task:', this.pendingTaskId);
      }
    },
    formatTaskDescription(task) {
      return `${task.task_no} | ${task.chapt_no} | ${task.question} | ${task.category} | ${task.assessment_type}`;
    },
    getAvailableTasksForDropdown(currentIndex) {
      const selectedIds = this.ahdTaskDetails
        .map((task, index) => {
          if (index === currentIndex || !task) return null;
          return Number(task.assessment_task_id);
        })
        .filter(Boolean);
 
      return this.filteredTasks.filter(task => {
        return !selectedIds.includes(Number(task.assessment_task_id));
      });
    },
    clearAssessorSignature() {
      if (this.isSubmitted <= 3 && this.assessorSignaturePad) {
        this.assessorSignaturePad.clear();
      }
    },
    clearTraineeSignature() {
      if (this.isSubmitted <= 3 && this.traineeSignaturePad) {
        this.traineeSignaturePad.clear();
      }
    },
    initializeAssessorSignaturePad() {
      const canvas = this.$refs.assessorSignaturePadCanvas;
      if (!canvas) return;
 
      // --- Handle device pixel ratio scaling ---
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      const ctx = canvas.getContext('2d');
      ctx.scale(ratio, ratio);
 
      // --- Initialize SignaturePad ---
      this.assessorSignaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        minWidth: 0.5,
        maxWidth: 1.5,
      });
 
      // --- Load existing signature (if any) ---
      if (this.assessorSignature) {
        const image = new Image();
        image.onload = () => {
          ctx.drawImage(image, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
        };
        image.src = this.assessorSignature;
      }
 
      if (this.isSubmitted > 3) {
        this.assessorSignaturePad.off();
        canvas.style.opacity = '0.5';
        } else {
          canvas.style.opacity = '1';
        }
    },
    initializeTraineeSignaturePad() {
      const canvas = this.$refs.traineeSignaturePadCanvas;
      if (!canvas) return;
 
      // Handle device pixel ratio scaling
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      const ctx = canvas.getContext('2d');
      ctx.scale(ratio, ratio);
 
      // Initialize SignaturePad
      this.traineeSignaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        minWidth: 0.5,
        maxWidth: 1.5,
      });
 
      // Load existing signature (if any)
      if (this.traineeSignature) {
        const image = new Image();
        image.onload = () => {
          ctx.drawImage(image, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
        };
        image.src = this.traineeSignature;
      }
 
      // Disable if submitted
      if (this.isSubmitted > 1 || this.isDisabled) {
        this.traineeSignaturePad.off();
        canvas.style.opacity = '0.5';
      } else {
        canvas.style.opacity = '1';
      }
    },
    destroySignaturePad() {
      if (this.assessorSignaturePad) {
        this.assessorSignaturePad.off();  // Turn off the signature pad
        this.assessorSignaturePad = null; // Clean up the reference
      }
      if (this.traineeSignaturePad) {
        this.traineeSignaturePad.off();  // Turn off the signature pad
        this.traineeSignaturePad = null; // Clean up the reference
      }
    },
    submitTaskSelection() {
      if (!this.taskDetails) {
        alert("Please select an assessment task before submitting.");
        return;
      }

      if (!this.date) {
        alert("Please select a date before submitting.");
        return;
      }

      const assessmentEntryData = {
        logbook_id: Number(this.logbookId),
        trainee_id: this.trainee.user_id,
        instructor_id: Number(this.instructorId),
        assessment_task_id: this.taskDetails.assessment_task_id,
        date: this.date,
        attempt_no: this.attemptNo,
        is_selected: 1,
        is_submitted: 1,
      };

      console.log('Submitting initial task selection:', assessmentEntryData);

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      axios.post('/api/assessments', assessmentEntryData, { headers })
        .then(response => {
          this.assessmentEntryId = response.data.id;
          this.isSubmitted = 1;
          console.log('Task selection saved:', response);
          alert('Task selection saved');
          this.close();
        })
        .catch(error => {
          console.error('There was an error saving the task selection:', error);
          if (error.isOffline === true) {
            this.$emit('close');
            return;
          }
          alert('Failed to save the task selection.');
        });
    },
    submitTaskAssessment() {
      // Check if the trainee signature is empty
      if (this.assessorSignaturePad.isEmpty() && this.assessorSignature === null) {
        alert("Please provide a signature before submitting.");
        return;
      }
 
      const isTraineeComplete = this.systemComponents && this.ataIntegration && this.technicalReference && this.maintenanceActions && this.melDeferral && this.closeUp && this.date;
 
      if (!isTraineeComplete) {
        alert("Please provide an answer under each question heading before submitting.");
        return;
      }
 
      const isAssessorComplete = this.assessmentResult;
 
      if (!isAssessorComplete) {
        alert("Please provide a signature and give final result submitting.");
        return;
      }
 
      // Confirm submission
      const confirmSubmission = confirm("Once submitted, the form cannot be edited. Are you sure you want to submit?");
      if (confirmSubmission && this.isSubmitted <= 3) {
        this.isSubmitted = 4; // Set form to readonly
        this.save(4); // Pass true to indicate submission
      }
    },
    save(isSubmitting = 0) {
      const assessmentEntryData = {
        logbook_id: Number(this.logbookId),
        trainee_id: this.trainee.user_id,
        instructor_id: Number(this.instructorId),
        assessment_task_id: this.taskDetails ? this.taskDetails.assessment_task_id : null,
        ATA_integration: this.ataIntegration,
        component_location: this.systemComponents,
        technical_reference: this.technicalReference,
        maintenance_actions: this.maintenanceActions,
        MEL_deferral: this.melDeferral,
        close_up: this.closeUp,
        extra_info: this.extraInfo,
        result: this.assessmentResult,
        date: this.date || null,
        assessor_signature: this.assessorSignaturePad.isEmpty()
          ? this.assessorSignature
          : this.assessorSignaturePad.toDataURL(),
        trainee_signature: this.traineeSignaturePad.isEmpty()
          ? this.traineeSignature
          : this.traineeSignaturePad.toDataURL(),
          attempt_no: this.attemptNo,
        is_selected: 1,
        is_submitted: Number(isSubmitting),
      };
      console.log('taskassess')
      console.log(assessmentEntryData);
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
 
      console.log('this.assessmentEntryId');
      console.log(this.assessmentEntryId);
 
      if (this.assessmentEntryId) {
        axios.put(`/api/assessments/${this.assessmentEntryId}`, assessmentEntryData, { headers })
          .then(response => {
            alert('Task Assessment updated successfully.', response);
            console.log(response);
            console.log("Saving Task Assessment Data:", assessmentEntryData);
            this.close();
            //this.populateTaskAssessmentData(response.data);
          })
          .catch(error => {
            console.error('There was an error updating the Task Assessment:', error);
            alert('Failed to update the Task Assessment.');
          });
      } else {
        // POST request if this is a new Task Assessment
        axios.post('/api/assessments', assessmentEntryData, { headers })
          .then(response => {
            alert('Task Assessment saved successfully.', response);
            console.log(response);
            this.assessmentEntryId = response.data.id;
            console.log("Saving Task Assessment Data:", assessmentEntryData);
            this.close();
          })
          .catch(error => {
            console.error('There was an error saving the Task Assessment:', error);
            if (error.isOffline === true) {
              this.$emit('close');
              return;
            }
            alert('Failed to save the Task Assessment.');
          });
      }
    },
    async populateTaskAssessmentData(assessmentEntryData) {
      if (!assessmentEntryData) {
        console.error('No Task Assessment data found');
        return;
      }
 
      // Check if the trainee and logbook IDs match
      if ((assessmentEntryData.trainee_id !== this.trainee.user_id) || (assessmentEntryData.logbook_id !== parseInt(this.logbookId))) {
        console.warn('Trainee or Logbook ID does not match. Data will not be populated.');
        return;
      }
 
      this.traineeSignature = assessmentEntryData.trainee_signature;
      this.assessorSignature = assessmentEntryData.assessor_signature;
 
      // Assign other values
      this.assessmentEntryId = assessmentEntryData.id;
      this.pendingTaskId = assessmentEntryData.assessment_task_id;
      this.resolveTaskDetails();
      this.assessorNotes = assessmentEntryData.notes;
      this.successfulChecked = assessmentEntryData.result === 'pass';
      this.remedialChecked = assessmentEntryData.result === 'fail';
      this.date = assessmentEntryData.date;
      this.isSubmitted = assessmentEntryData.is_submitted;
      this.ataIntegration = assessmentEntryData.ATA_integration;
      this.systemComponents = assessmentEntryData.component_location;
      this.technicalReference = assessmentEntryData.technical_reference;
      this.maintenanceActions = assessmentEntryData.maintenance_actions;
      this.melDeferral = assessmentEntryData.MEL_deferral;
      this.closeUp = assessmentEntryData.close_up;
      this.extraInfo = assessmentEntryData.extra_info;
      this.instructorId = assessmentEntryData.instructor_id;
      this.assessmentResult = assessmentEntryData.result;
 
      if (this.instructorId !== null) {
        this.assessorName = this.instructor.first_name + ' ' + this.instructor.last_name;
      }
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
 
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    async fetchData() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
 
        // Fetch product
        const productRes = await axios.get(`/api/products/${this.productId}`, { headers });
        this.product = productRes.data;
        console.log('Fetched Product:', this.product);
        console.log('Product ac_id:', this.product.ac_id);
        this.courseCode = this.product.product_code;
 
        // Now that this.product is set, fetch aircraft
        const aircraftRes = await axios.get(`/api/aircraft/${this.product.ac_id}`, { headers });
        this.aircraft = aircraftRes.data;
        console.log('Fetched Aircraft:', this.aircraft);
 
        // Fetch specifics
        const specificsRes = await axios.get(`/api/specifics/${this.product.spec_id}`, { headers });
        this.specific = specificsRes.data;
        console.log('Fetched Specific:', this.specific);
        this.aircraftType = this.aircraft.name + ` (${this.specific.name})`;
 
 
      } catch (error) {
        console.error("Error during fetch:", error);
      }
    }
  },
  async mounted() {
    this.isVisible = true;
    this.traineeName = this.trainee.first_name + ' ' + this.trainee.last_name;
 
    // Wait for product (and therefore assessment_criteria) to load before
    // resolving/formatting tasks, since formatTaskDescription depends on it.
    await this.fetchData();
    console.log('inst', this.instructor);
    this.assessorName = this.instructor.first_name + ' ' + this.instructor.last_name;
 
    if (this.fetchedData) {
      this.populateTaskAssessmentData(this.fetchedData);
    }
    this.$nextTick(() => {
      this.initializeAssessorSignaturePad();
      this.initializeTraineeSignaturePad();
    });
 
  },
  beforeUnmount() { // or beforeDestroy() for Vue 2
    this.destroySignaturePad();
  }
}
</script>


<style scoped>
.Evaluation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  max-height: 98vh;
  max-width: 90vw;
  min-width: 85vw;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
}

.assessment-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  align-items: center;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #c7c7c7;
  padding: 6px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 16px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 20px;
  /* Adjust as needed */
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-save-button:hover {
  background-color: #0462c7;
}

.ins-submit-button {
  background-color: brown;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  min-width: 100px;
  max-width: 120px;
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}


.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.ins-close-button:hover {
  background-color: #545a5f;
}

.ins-clear-button {
  background-color: #ee9581;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 20px;
  width: 100%;
  min-width: 60px;
  max-width: 100px;
  border: 1px solid #c7715e;
  height: 30px;
}

.ins-clear-button:hover {
  background-color: #e47a62;
}

.tee-clear-button {
  background-color: #ee9581;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 20px;
  width: 100%;
  min-width: 60px;
  max-width: 100px;
  border: 1px solid #c7715e;
  height: 30px;
}

.tee-clear-button:hover {
  background-color: #e47a62;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled,
.tee-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey;
  border: 1px solid rgb(92, 92, 92);
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover,
.tee-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey;
  border: 1px solid rgb(92, 92, 92);
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  padding: 20px;
  background-color: #eeeeee;
  border-radius: 2px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllYes {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
  width: 280px;
  height: 80px;
}

.right {
  display: flex;
  justify-content: flex-end;
}

.assessment-result {
  width: 100%;
  background-color: #eeeeee;
  padding: 20px 0;
  display: flex;
  justify-content: center; /* center the child horizontally */
  box-sizing: border-box;
  border-radius: 2px;
}

.assessment-result table {
  width: auto; /* or a fixed width like 60% if you prefer */
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.artificial-fieldset {
  border: 1px solid #8b8b8b;
  padding: 10px;
  margin-top: 20px;
  position: relative;
  margin-bottom: 20px;
}

.artificial-fieldset-legend {
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: #e4e4e4;
  padding: 0 10px;
  font-weight: bold;
  border: 1px solid #8b8b8b;
  border-radius: 3px;
}

.additional-info-table {
  text-align: left;
  margin-top: 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 5px;
}

.additional-info-table td:nth-child(1) {
  width: 15%;
  border-radius: 3px;
}

.additional-info-table td:nth-child(2) {
  width: 35%;
}

.additional-info-table td:nth-child(3) {
  width: 20%;
  padding-left: 20px;
}

.additional-info-table td:nth-child(4) {
  width: 25%;
}

.additional-info-table td:nth-child(5) {
  width: 10%;
}

.additional-info-table td:nth-child(6) {
  width: 20%;
}

.additional-info-table input {
  height: 25px;
}

label {
  margin-bottom: 0px;
}

.additional-info-table td {
  padding: 5px;
}

.instructor_signoff {
  border: none;
  color: #3e9651 !important;
  background: none;
  font-weight: bold;
  padding: 0px;
  width: 80px;
}

.instructor_signoff:hover {
  background-color: white !important;
  font-weight: bold;
}

.instructor_signoff:disabled {
  border: none;
  color: rgb(97, 97, 97) !important;
  background: none;
  font-weight: 400;
  cursor: not-allowed;
}

input[disabled],
textarea[disabled],
label[disabled],
canvas[disabled] {
  cursor: not-allowed;
}

</style>